import { render } from "./IndexAbout.vue?vue&type=template&id=7d75341e"
import script from "./IndexAbout.vue?vue&type=script&lang=js"
export * from "./IndexAbout.vue?vue&type=script&lang=js"

import exportComponent from "/opt/microsoft-academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__